type Modifier = 'CTRL' | 'SHIFT' | 'ALT' | 'WIN';

type KeybindProps = {
  modifiers: Modifier[];
  shortcutKey: string;
};

function getPlatformString() {
  if (typeof window === 'undefined') {
    return '';
  }

  // userAgentData isn't implemented in most browser-OS combinations yet, and the old
  // navigator.platform is deprecated and may be removed. We're gonna take whatever's available.
  return (
    (window.navigator as Navigator & { userAgentData?: { platform: string } }).userAgentData
      ?.platform || window.navigator.platform
  );
}

function modifierText(modifier: Modifier) {
  switch (modifier) {
    case 'CTRL':
      return 'Ctrl';
    case 'SHIFT':
      return 'Shift';
    case 'ALT':
      return 'Alt';
    case 'WIN':
      if (getPlatformString().startsWith('Win')) {
        return 'Win';
      }
      if (getPlatformString().toLowerCase().startsWith('mac')) {
        return '⌘';
      }
      return 'Super';
  }
}

export function Keybind({ modifiers, shortcutKey }: KeybindProps) {
  const text = modifiers.map((modifier) => `${modifierText(modifier)}+`).join('') + shortcutKey;

  return (
    <kbd className="inline-flex items-center rounded-md border border-gray-200 px-2 font-sans text-gray-400 text-sm">
      {text}
    </kbd>
  );
}
